import script from "./DownloadsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadsView.vue?vue&type=script&lang=ts&setup=true"

import "./DownloadsView.vue?vue&type=style&index=0&id=767025ee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767025ee"]])

export default __exports__